import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class IsStateActiveHelper extends Helper {
  @service routeState;

  compute(routeParams, options) {
    return this.routeState.isActive(routeParams, options);
  }
}
